import { Navigate } from "react-router-dom";
import { useSession } from "../lib/auth-client";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { data: session, isPending } = useSession();

  if (isPending) return <div className="p-8 text-center text-gray-400">Loading...</div>;
  if (!session) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
